import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import HomePage from './pages/HomePage.jsx';
import Help from './pages/Help.jsx';
import QuestionOfTheDay from './pages/QuestionOfTheDay.jsx'; 
import RecentScores from './pages/RecentScores.jsx';
import AcknowledgementsPage from './pages/Acknowledgments.jsx'
import 'antd/dist/reset.css';
import './index.css';
import ScrollToTop from './components/ScrollToTop.jsx';
import AuthorPage from './pages/AuthorPage.jsx';

function NotFound() {
  return (
    <div className="max-w-4xl mx-auto p-8">
      <h1 className="text-2xl font-bold">404 — Page not found</h1>
      <p className="mt-3">The page you requested could not be found.</p>
      <a href="/" className="mt-4 inline-block text-[#00AAB5]" rel="noopener noreferrer">Back to home</a>
    </div>
  );
}

function Root() {
  return (
    <BrowserRouter basename={process.env.REACT_APP_URLS_FOR_BASE} >
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="/help" element={<Help />} />
          <Route path="/question-of-the-day" element={<QuestionOfTheDay />} />
          <Route path="/top-scores" element={<RecentScores />} />
          <Route path="/acknowledgements" element={<AcknowledgementsPage />} />
          <Route path="/authors" element={<AuthorPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root />);
